<template>
  <div class="table-responsive">
    <table class="table align-items-center table-flush kc-lines">
      <thead class="thead-light">
        <tr>
          <th scope="col">{{ copy.lines.item }}</th>
          <th scope="col" class="text-right">{{ copy.lines.quantity }}</th>
          <th scope="col" class="text-right">{{ copy.lines.price }}</th>
          <th scope="col" class="text-right">{{ copy.lines.total }}</th>
        </tr>
      </thead>
      <tbody v-for="group in groups" :key="group.key">
        <tr class="kc-group-row">
          <th scope="colgroup" :colspan="columnCount">{{ group.label }}</th>
        </tr>
        <tr v-for="(row, index) in group.rows" :key="index">
          <td class="kc-item">{{ row.name }}</td>
          <td class="text-right kc-number">{{ row.quantity }}</td>
          <td class="text-right kc-number" :class="{ 'text-warning': row.isPriceMissing }">{{ row.price }}</td>
          <td class="text-right kc-number" :class="{ 'text-muted': row.isPriceMissing }">{{ row.total }}</td>
        </tr>
        <tr class="kc-subtotal-row">
          <td :colspan="columnCount - 1" class="text-right">{{ group.subtotalLabel }}</td>
          <td class="text-right kc-number">{{ group.subtotalText }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="kc-total-row">
          <td :colspan="columnCount - 1" class="text-right">
            <badge v-if="detail.isIncomplete" type="warning" class="mr-2">{{ copy.incomplete }}</badge>
            {{ detail.totalLabel }}
          </td>
          <td class="text-right kc-number">{{ detail.total }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import { KITCHEN_CHARGES_COPY } from '@/components/KitchenCharges/copy';
import { formatMoney } from '@/components/KitchenCharges/chargeMoney';
import { lineRow } from '@/components/KitchenCharges/chargeDetails';

const COLUMN_COUNT = 4;

export default {
  name: 'KitchenChargeLineGroups',
  props: {
    detail: { type: Object, required: true },
    currency: { type: String, required: true },
  },
  data() {
    return { copy: KITCHEN_CHARGES_COPY, columnCount: COLUMN_COUNT };
  },
  computed: {
    groups() {
      return this.detail.groups.map((group) => ({
        ...group,
        subtotalText: formatMoney(group.subtotal, this.currency),
        rows: group.lines.map((line) => lineRow(line, this.currency)),
      }));
    },
  },
};
</script>

<style scoped>
.kc-lines td,
.kc-lines th { white-space: normal; }
.kc-item { min-width: 180px; }
.kc-lines .kc-number {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.kc-group-row th {
  background: #f6f9fc;
  color: #32325d;
  font-weight: 600;
}
.kc-subtotal-row td {
  font-weight: 600;
  color: #32325d;
}
.kc-total-row td {
  font-size: 1rem;
  font-weight: 700;
  color: #32325d;
  border-top: 2px solid #e9ecef;
}
</style>
